import React, { useState } from "react";
import "./index.css";
import UploadModal from "./UploadModal";

const AiFilesUploader = ({ type, buttonTitle }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <button className="button is-primary is-small" onClick={() => setIsOpen(true)}>
        {buttonTitle}
      </button>
      <UploadModal isOpen={isOpen} type={type} toggleModal={(isOpen) => setIsOpen(isOpen)} />
    </div>
  );
};

export default AiFilesUploader;
